import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { LoanPaymentKind } from "../../models/enums/loan-payment-kind";
import { HrmLoanToPersonnel } from "../../models/hrm-loan-to-personnel.model";

@Component({
  selector: "ngx-hrm-loan-to-personnel-form",
  templateUrl: "./hrm-loan-to-personnel-form.component.html",
  styleUrls: ["./hrm-loan-to-personnel-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HrmLoanToPersonnelFormComponent extends BaseFormComponent<HrmLoanToPersonnel> {
  erroremessage: string;
  public apiName: string = "HrmLoanToPersonnel";
  public label: string = "تخصیص وام به کارکنان";
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private lookupservice: LookupService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    super.ngOnInit();
  }
  setdefault(): void {
    if (this.isNewRow && !this.model.LoanPaymentKindId) {
      this.lookupservice
        .getLookupbyCode("HRM", "LoanPaymentKind", LoanPaymentKind.LastPayment)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.LoanPaymentKindId = x.Id;
          this.model.LoanPaymentKindTitle = x.Title;
          this.setValue("LoanPaymentKindId", x.Id);
          this.setValue("LoanPaymentKindTitle", x.Title);
        });
    }
    if (!this.model.LoanStartYear) this.model.LoanStartYear = this.accountService.authService.currentFiscalYear.Year;
    if (!this.model.LoanYear) this.model.LoanYear = this.accountService.authService.currentFiscalYear.Year;
  }
  onChange($event) {
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("HrmLoanKind") && $event.KeyName === "HrmLoanKindId") {
      this.setValue("LoanTop", $event.data.LoanTop);
      this.model.LoanTop = $event.data.LoanTop;
      this.model.LoanAmount = $event.data.LoanTop;
      this.setValue("LoanAmount", $event.data.LoanTop);
      this.model.LoanStartRemain = $event.data.LoanTop;
      this.setValue("LoanStartRemain", $event.data.LoanTop);
      this.setValue("LoanTopControl", $event.data.LoanTopControl);
      this.model.LoanTopControl = $event.data.LoanTopControl;
    }
  }
  isValid(): boolean {
    let flag: boolean = true;
    if (this.model.LoanTopControl && this.formGroup.controls["LoanAmount"].value > this.model.LoanTop) {
      flag = false;
      this.erroremessage = "سقف وام بیش از سقف مجاز است.";
    }
    return flag;
  }
  onvalueChange($event) {
    if (
      this.formGroup.controls["LoanAmount"].value &&
      (!this.formGroup.controls["LoanStartRemain"].value ||
        this.formGroup.controls["LoanStartRemain"].value > this.formGroup.controls["LoanPayment"].value)
    ) {
      this.setValue("LoanStartRemain", this.formGroup.controls["LoanAmount"].value);
    }
    if (this.formGroup.controls["LoanStartRemain"].value && this.formGroup.controls["LoanPayment"].value) {
      let LoanLeftOver = this.formGroup.controls["LoanStartRemain"].value % this.formGroup.controls["LoanPayment"].value;
      let LoanPaymentCount = Math.floor(this.formGroup.controls["LoanStartRemain"].value / this.formGroup.controls["LoanPayment"].value);
      this.setValue("LoanPaymentCount", LoanPaymentCount);
      this.setValue("LoanLeftOver", LoanLeftOver);
    }
  }
}
